import styled from "styled-components";

export const AnnouncementsContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px 48px;
  align-items: center;
`;

export const AnnouncementsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(
    ${({ numberOfColumns }) => numberOfColumns},
    minmax(0, 1fr)
  );
  grid-auto-rows: 1fr;
  gap: 20px;
  width: 100%;
  padding: 2px 2px 4px;
  box-sizing: border-box;
`;

export const DesignContainer = styled.div`
  position: relative;
  border-radius: 13px;
  height: fit-content;
  cursor: pointer;
  height: 100%;

  ${({ isSelected }) =>
    isSelected &&
    `outline-offset: 3px;
    outline: 6px solid #00afff4d;`};

  ${({ hasHover, theme }) =>
    hasHover &&
    `
    &:hover {
      outline-offset: 3px;
      outline: 6px solid ${theme.border.brand}4d;
    }`};
`;
